import React, { SyntheticEvent, useEffect, useState } from 'react';
import styles from './AgregatorsFilter.module.scss';
import filtersStyles from '../../Filters.module.scss';
import { Action, CloseLight } from 'esa-ui-library';
import { useStore } from '../../../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { find } from 'lodash';
import { getActiveLabels, getFilterValue, getUpdateOptions, selectPreselectedOptions } from '../../Filters.helper';
import { getPreselectedAggregator } from '../../../../pages/GamblingReport/GamblingReport.helper';
import useFilters from '../../../../../common/hooks/useFilters';

const AgregatorsFilter = (): JSX.Element => {
	const [{ gamblingReportList, filters }] = useStore();
	const [opened, setOpened] = useState(false);
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const { onFilter } = useFilters();

	const onAgregatorsChange = (agregator: PropertyType) => {
		const updateOptions = getUpdateOptions(agregator, gamblingReportList);
		const filterValue = getFilterValue(updateOptions);
		setOpened(false);
		onFilter([{ name: 'aggregators', value: filterValue }]);
	};

	const onAgregatorsRemove = (e: SyntheticEvent) => {
		e.stopPropagation();
		onFilter([{ name: 'aggregators', value: '' }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onAgregatorsRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	useEffect(() => {
		if (gamblingReportList) {
			const aggregatorID = getPreselectedAggregator(gamblingReportList);
			onFilter([{ name: 'aggregators', value: aggregatorID }]);
		}
	}, [gamblingReportList]);

	useEffect(() => {
		const filter = find(filters, ['name', 'aggregators'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(gamblingReportList, filter));
	}, [filters]);

	return (
		<Action
			label='List'
			labelContent={getLabelContent()}
			controlled
			onDropdownChange={setOpened}
			opened={opened}
			className={`
			${filtersStyles.Filter} 
			${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} 
			${styles.Filter}`}
			dataId='agregators-filter'
		>
			<FilterDropdown data={filterOptions} onChange={onAgregatorsChange} isSearchable />
		</Action>
	);
};

export { AgregatorsFilter };
